(() => {
  const storageKey = 'malvros-color-mode';
  const root = document.documentElement;
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  const currentMode = () => (root.dataset.colorMode === 'dark' ? 'dark' : 'light');

  const updateButtons = () => {
    const isDark = currentMode() === 'dark';

    document.querySelectorAll('[data-color-mode-toggle]').forEach((button) => {
      const label = isDark ? button.dataset.lightModeLabel : button.dataset.darkModeLabel;
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);

      const hiddenLabel = button.querySelector('[data-color-mode-label]');
      if (hiddenLabel) hiddenLabel.textContent = label;
    });
  };

  const applyMode = (mode, savePreference = false) => {
    const safeMode = mode === 'dark' ? 'dark' : 'light';
    root.dataset.colorMode = safeMode;
    root.style.colorScheme = safeMode;

    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) themeColor.setAttribute('content', safeMode === 'dark' ? '#121212' : '#fafaf7');

    if (savePreference) {
      try {
        localStorage.setItem(storageKey, safeMode);
      } catch (error) {
        // The switch still works when storage is unavailable.
      }
    }

    updateButtons();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-color-mode-toggle]');
    if (!button) return;

    applyMode(currentMode() === 'dark' ? 'light' : 'dark', true);
  });

  document.addEventListener('shopify:section:load', updateButtons);

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey && (event.newValue === 'dark' || event.newValue === 'light')) {
      applyMode(event.newValue);
    }
  });

  const handleSystemModeChange = (event) => {
    try {
      if (localStorage.getItem(storageKey)) return;
    } catch (error) {
      // Follow the system setting when storage is unavailable.
    }
    applyMode(event.matches ? 'dark' : 'light');
  };

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', handleSystemModeChange);
  } else if (typeof mediaQuery.addListener === 'function') {
    mediaQuery.addListener(handleSystemModeChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateButtons, { once: true });
  } else {
    updateButtons();
  }
})();
